import css from './index.module.css';

/**
 * custom input component
 */
const Input = ({type, placeholder, label, value, defaultValue, simple, id, name, style, onChange, min, max, maxlength, disabled}) => {
    return (
        <div className={css.container}>
            {!simple && <span className={css.label}>{label}</span>}
            {disabled ? 
                <input 
                    className={style ? style : css.input} 
                    type={type} 
                    placeholder={placeholder} 
                    value={value} 
                    defaultValue={defaultValue} 
                    id={id} name={name} 
                    onChange={onChange} 
                    min={min} max={max} 
                    maxLength={maxlength} 
                    readOnly={true}
                /> :
                <input 
                    className={style ? style : css.input} 
                    type={type} 
                    placeholder={placeholder} 
                    value={value} 
                    defaultValue={defaultValue} 
                    id={id} name={name} 
                    onChange={onChange} 
                    min={min} 
                    max={max} 
                    maxLength={maxlength}
                />
            }
        </div>
    ) 
    
};

export default Input;